var path = '/templates/projects.clearance/clearance_set_show.html';
var html = "<div class=container><zc-clearance-item-list project=project clearance-item-set=clearanceItemSet></zc-clearance-item-list></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.clearance/clearance_set_show.html
// module id = 1448
// module chunks = 0